import { useContext, useEffect } from "react";
import MainContext from "../../context/mainContext";
import { Box } from "@mui/material";
import styles from "./MyTasks.module.scss";
import MyTasksList from "./MyTasksList";
import MyTasksTitle from "./MyTasksTitle";

const MyTasks: React.FC = () => {
  const { setBanner } = useContext(MainContext);
  useEffect(() => {
    setBanner("drone-beach.png");
  });
  
  return (
    <Box className={styles.myInboxMain}>
      <MyTasksTitle />
      <MyTasksList showBack />
    </Box>
  );
};

export default MyTasks;
